import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forRoot([
        { path: '', redirectTo: 'home', pathMatch: 'full' },
        { path: 'login', loadChildren: './login/login.module#LoginModule' },
        { path: 'access-denied', loadChildren: './components/access-denied/access-denied.module#AccessDeniedModule' },
        { path: 'versions-not-compatible', loadChildren: './components/versions-not-compatible/versions-not-compatible.module#VersionsNotCompatibleModule' },
        { path: 'home', loadChildren: './home/home.module#HomeModule' },
        { path: 'orders', loadChildren: './orders/orders.module#OrdersModule' },
        { path: 'marketingpurchases', loadChildren: './marketing-purchases/marketing-purchases.module#MarketingPurchasesModule' },
        { path: 'buffertable', loadChildren: './buffer-table/buffer-table.module#BufferTableModule' },
        { path: 'changebuffer', loadChildren: './change-buffer/change-buffer.module#ChangeBufferModule' },
        { path: 'importassortment', loadChildren: './import-assortment/import-assortment.module#ImportAssortmentModule' },
        { path: 'schedule', loadChildren: './supply-schedule/supply-schedule.module#SupplyScheduleModule' },
        { path: '**', redirectTo: 'home' }
    ])
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts